import { useEffect, useState, type ReactNode } from 'react';
import { Circle, Clock } from 'lucide-react';

function useElapsed(start: number): string {
  const [, force] = useState(0);
  useEffect(() => {
    const t = setInterval(() => force((n) => n + 1), 1000);
    return () => clearInterval(t);
  }, []);
  const secs = Math.floor((Date.now() - start) / 1000);
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}

export default function TopBar({
  title,
  recording,
  extra,
}: {
  title: string;
  recording: boolean;
  extra?: ReactNode;
}): JSX.Element {
  const [start] = useState(() => Date.now());
  const elapsed = useElapsed(start);

  return (
    <div className="flex items-center justify-between border-b border-slate-800 bg-slate-900 px-4 py-2 text-slate-200">
      <div className="flex items-center gap-3">
        <span className="font-semibold">{title}</span>
        {recording && (
          <span className="flex items-center gap-1 rounded-full bg-red-500/20 px-2 py-0.5 text-xs text-red-400">
            <Circle size={8} className="fill-red-500 text-red-500 animate-pulse" /> REC
          </span>
        )}
      </div>
      <div className="flex items-center gap-3 text-sm text-slate-400">
        {extra}
        <span className="flex items-center gap-1">
          <Clock size={14} /> {elapsed}
        </span>
      </div>
    </div>
  );
}
